import React from "react";
import onionImg from "./Banana.png";

export default function ProductDetails({ isMobile }) {
  const handleCall = () => {
    window.location.href = "tel:7981982642";
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "25px" : "40px",
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      {/* LEFT SECTION */}
      <div
        style={{
          width: isMobile ? "100%" : "35%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Main Image */}
        <img
          src={onionImg}
          alt="product"
          style={{
            width: "100%",
            maxWidth: "350px",
            borderRadius: "12px",
          }}
        />

        {/* Thumbnails */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "15px",
            justifyContent: "center",
          }}
        >
          {[1, 2, 3, 4].map((_, i) => (
            <img
              key={i}
              src={onionImg}
              alt="thumb"
              style={{
                width: "60px",
                height: "60px",
                objectFit: "cover",
                borderRadius: "10px",
                border: "2px solid #e0e0e0",
                cursor: "pointer",
              }}
            />
          ))}
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div
        style={{
          width: isMobile ? "100%" : "60%",
          textAlign: "left",
        }}
      >
        <h2
          style={{
            fontSize: isMobile ? "22px" : "32px",
            fontWeight: "600",
            marginBottom: "8px",
          }}
        >
          Banana Powder
        </h2>

        <p style={{ fontSize: "18px", color: "green", marginBottom: "12px" }}>
          ⭐ 4.5
        </p>

        <p><b>Category:</b> Banana</p>
        <p><b>Product ID:</b> CBP-500G-IND-0725</p>

        <p
          style={{
            marginTop: "15px",
            marginBottom: "20px",
            lineHeight: "1.6",
          }}
        >
         It is a fine, light-coloured powder made from ripe bananas that are peeled, 
sliced, dried, and ground. It retains much of the original banana flavour, aroma, and 
nutritional properties, making it a popular ingredient in food and health industries.


        </p>

        <h3 style={{ marginBottom: "10px" }}>Available quantities</h3>

        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            marginBottom: "20px",
          }}
        >
          <button style={btn}>in Kg</button>
          <button style={btn}>in tons</button>
          <button style={btn}>in ounces</button>
          <button style={btn}>in pounds</button>
        </div>

        {/* CALL BUTTON */}
        <button
          onClick={handleCall}
          style={{
            padding: "12px 28px",
            backgroundColor: "green",
            color: "white",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          Quote order
        </button>
      </div>
    </div>
  );
}

const btn = {
  padding: "8px 15px",
  borderRadius: "8px",
  border: "1px solid #ffffffff",
  cursor: "pointer",
  background: "white",
};